import React from "react";
import SmartLink from "./SmartLink";

export const UPDATE_TYPE_LABELS = {
  new: "New tool",
  update: "Update",
  fix: "Fix",
};

export function formatUpdateDate(date) {
  const parsed = new Date(`${date}T00:00:00`);
  if (Number.isNaN(parsed.getTime())) return date;
  return parsed.toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" });
}

export default function UpdatesTimeline({ updates }) {
  return (
    <ol className="updates-timeline">
      {updates.map((update) => {
        const href = update.link || update.product?.link;
        return (
          <li className={`updates-entry updates-entry--${update.type}`} key={update.id}>
            <span className="updates-entry__dot" aria-hidden="true" />
            <article className="updates-entry__card">
              {update.product?.image && (
                <img className="updates-entry__thumb" src={update.product.image} alt="" loading="lazy" />
              )}
              <div className="updates-entry__body">
                <div className="updates-entry__meta font-mono">
                  <span className={`updates-badge updates-badge--${update.type}`}>
                    {UPDATE_TYPE_LABELS[update.type] || update.type}
                  </span>
                  {update.version && <span className="updates-entry__version">v{update.version.replace(/^v/i, "")}</span>}
                  <time dateTime={update.date}>{formatUpdateDate(update.date)}</time>
                </div>
                <h3>
                  {update.product?.name && !update.title.toLowerCase().includes(update.product.name.toLowerCase()) && (
                    <span className="updates-entry__tool">{update.product.name} · </span>
                  )}
                  {update.title}
                </h3>
                {update.summary && <p>{update.summary}</p>}
                {href && (
                  <SmartLink href={href} className="updates-entry__link font-mono">
                    View tool <i className="fas fa-arrow-right" aria-hidden="true" />
                  </SmartLink>
                )}
              </div>
            </article>
          </li>
        );
      })}
    </ol>
  );
}
